import {createContext} from 'react';
import '../lang/en.json';
export const LangContext = createContext();